import React from "react";
import SEOLandingPage from "../../../components/tools/SEOLandingPage";

const PDFToFlashcards: React.FC = () => {
  return (
    <SEOLandingPage
      // SEO
      title="PDF to Flashcards Converter - AI Study Cards from PDFs | YouWo AI"
      metaDescription="Convert PDF textbooks and notes to flashcards automatically. Upload any PDF and get study-ready flashcards in seconds. Free AI-powered PDF to flashcard converter."
      keywords="pdf to flashcards, convert pdf to flashcards, flashcards from pdf, pdf flashcard maker, textbook to flashcards, study cards from pdf"
      canonicalUrl="https://youwo.ai/tools/pdf-to-flashcards"
      // Hero
      headline="Convert Any PDF to Study Flashcards"
      subheadline="Upload a textbook chapter or study guide and get flashcards instantly. AI identifies key concepts, definitions, and facts worth memorizing."
      heroIcon="lucide:file-output"
      heroIconColor="text-orange-500"
      heroIconBg="bg-orange-50"
      // Problem/Solution
      problemTitle="Reading PDFs Doesn't Mean Learning"
      problemDescription="You can read a textbook chapter five times and still forget the content. Passive reading doesn't create lasting memories. You need active recall to really learn."
      solutionTitle="Turn Reading into Active Learning"
      solutionDescription="Upload your PDF and our AI creates flashcards that force active recall. Each card tests a specific concept, making your study time far more effective than just re-reading."
      // Features
      features={[
        {
          icon: "lucide:brain",
          title: "Active Recall Learning",
          description: "Flashcards use active recall - the most effective learning technique.",
        },
        {
          icon: "lucide:globe",
          title: "100+ Languages",
          description: "Convert PDFs in over 100 languages to flashcards.",
        },
        {
          icon: "lucide:upload",
          title: "Drag & Drop Upload",
          description: "Simply drag any PDF file and get flashcards within seconds.",
        },
        {
          icon: "lucide:sliders",
          title: "Customizable Output",
          description: "Choose how many cards to generate and their difficulty level.",
        },
        {
          icon: "lucide:edit",
          title: "Easy Editing",
          description: "Review and edit any generated flashcard before studying.",
        },
        {
          icon: "lucide:share-2",
          title: "Export with Pro",
          description: "Export flashcards to Anki, Quizlet with YouWo AI Pro.",
        },
      ]}
      // CTA
      ctaText="Convert PDF to Flashcards"
      ctaLink="https://apps.apple.com/app/youwo-ai-agent/id6760689478"
      // Related
      relatedTools={[
        { name: "AI Flashcard Maker", href: "/tools/flashcard-maker", icon: "lucide:layers" },
        { name: "PDF Summarizer", href: "/tools/pdf-summarizer", icon: "lucide:file-text" },
        { name: "PDF to Study Guide", href: "/tools/pdf-to-study-guide", icon: "lucide:book-open-check" },
        { name: "AI Quiz Generator", href: "/tools/quiz-generator", icon: "lucide:help-circle" },
        { name: "Quizlet Alternative", href: "/tools/quizlet-alternative", icon: "lucide:book-open" },
      ]}
    />
  );
};

export default PDFToFlashcards;
